var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-editor"},[_c('ckeditor',{attrs:{"id":_vm.id,"editor":_vm.editor,"config":_vm.editorConfig,"value":_vm.value,"disabled":_vm.readonly},on:{"input":_vm.handleUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }